$(window).scroll(function () {
    if ($(this).scrollTop() > 0) {
        $('nav').addClass('sticky');
    } else {
        $('nav').removeClass('sticky');
    }
});

window.onload = function () {

    let screenWidth = window.innerWidth;
    let screenHeight = window.innerHeight;
    let mobmenu = document.getElementById('mobmenu');
    let mobmenuflip = document.getElementById('mobmenuflip');

    const screenWidthCheck = screenWidth;

    mobmenu.style.left = screenWidth -55 + 'px';
    mobmenu.style.top = screenHeight -55 + 'px';

    let klik;


    window.onresize = function () {
        screenWidth = window.innerWidth ;
        screenHeight = window.innerHeight;

        if(screenWidth != screenWidthCheck) {
            mobmenu.style.left = screenWidth -55 + 'px';
            mobmenu.style.top = screenHeight -55 + 'px';
        }
    }

    window.flip = function () {
        mobmenuflip.style.transform = mobmenuflip.style.transform + 'rotateX(180deg)';
        console.log('flip');
        $('.mobilemenu').toggleClass('active');
    }

    mobmenu.addEventListener('touchstart', function (ev) {

        klik = 0;
        console.log(ev);
    });

    mobmenu.addEventListener('touchmove', function (ev) {

        klik = 1;

        let touchLocation = ev.targetTouches[0];
        mobmenu.style.left = touchLocation.pageX + 'px';
        mobmenu.style.top = (touchLocation.pageY - window.scrollY) + 'px';
        ev.preventDefault();
    });

    mobmenu.addEventListener('touchend', function (ev) {

        if (klik == 0) {
            flip(); //eslint-disable-line
        }
        console.log('end');

        let x = parseInt(mobmenu.style.left); //eslint-disable-line
        let y = parseInt(mobmenu.style.top); //eslint-disable-line

        ev.preventDefault();


    });
}



// WEBPACK FOOTER //
// ./scripts/modules/menu.js